/* @flow */

import { enableInitializing } from 'initializable-reducer';
import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import sortByName from '../helpers/sortByName';
import _ from 'lodash';

const initialState = [];

function schoolUserInvitations(state: Array<Object> = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_SCHOOL_USER_INVITATIONS':
      if (responseHasError(payload)) {
        return state;
      }

      return  _.sortBy(payload.body, 'created_at');  
    default:
      return state;
  }
}

export {
  schoolUserInvitations,
  initialState
};

export default enableInitializing(schoolUserInvitations);
